import { buildDataForPageView } from '../../../utils/shiftnative/utils';
import defaultMappings from './default';

export default {
	events: {
		'ddc.link.generic': [
			{
				logic: ({ eventData: { trackingSection, url } }) =>
					(trackingSection === 'Global Nav' ||
						trackingSection?.includes('nav-link')) &&
					url?.startsWith('https://buy.') &&
					!url?.includes('carbravo'),
				payload: ({
					eventData: { trackingSection, text },
					mapping
				}) => ({
					events: 'linkClick',
					data: {
						events: 'linkClick',
						linkText: text,
						linkType: 'CTA',
						location: trackingSection.toLowerCase(),
						pageType: buildDataForPageView({ mapping }).pageType, // Maybe this should be done in a sharedPayload instead?
						linkDestination: 'GMBuy'
					}
				})
			},
			{
				logic: ({ eventData }) => {
					let applyRule = window.DDC.dataLayer.page.pageInfo.isVlp;

					if (applyRule) {
						// Extract promotionId from the URL
						const url = eventData?.url || '';
						const urlParams = new URLSearchParams(
							url.split('?')[1] || ''
						);
						const promotionId = urlParams.get('promotionId');

						applyRule =
							promotionId &&
							window?.dataLayer &&
							eventData?.eventId;
					}

					return applyRule;
				},
				payload: ({ eventData }) => {
					// Find the position of the current ddc.link.generic event in the dataLayer
					const currentEventIndex = window.dataLayer.findIndex(
						(item) =>
							item.event === 'ddc.link.generic' &&
							item?.eventData?.eventId === eventData.eventId
					);

					// Find the closest previous specialsEvent with specialType 'click'
					let matchingEvent = null;
					if (currentEventIndex !== -1) {
						for (let i = currentEventIndex - 1; i >= 0; i--) {
							const item = window.dataLayer[i];
							if (
								item.event === 'specialsEvent' &&
								item.specialType === 'click'
							) {
								matchingEvent = item;
								break;
							}
						}
					}

					let linkType = '';

					if (matchingEvent?.specialPlacementType) {
						// Map specialPlacementType to linkType
						const placementTypeMap = {
							short_horizontal_srp: 'Pencil Banner',
							tall_vertical_srp: 'In Line Banner'
						};

						linkType =
							placementTypeMap[
								matchingEvent.specialPlacementType
							] || '';
					}

					return {
						data: {
							events: 'linkClick',
							linkType,
							location: 'Vehicle Listing Card',
							linkText: eventData?.oemId || ''
							// linkDestination: '' // out of scope unless banners link to GMBuy or CarBravo
						}
					};
				}
			},
			...defaultMappings.events['ddc.link.generic']
		]
	}
};
